import { Grid, CardActionArea, CardContent, Card, Typography, Chip, Box } from "@mui/material";

//TODO
//better styling - refactor to another file?
/*
                        <Typography variant="caption" gutterBottom>
                            Current task: {entry.currentTask}
                        </Typography>
                        <Typography variant="caption" gutterBottom>
                            Stack: {entry.techStack}
                        </Typography>
*/
function PortfolioEntry({ entry }) {
    return (
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <CardActionArea component="a" target="_blank" href={entry.link}>
                <Card sx={{ height: "200px" }}>
                    <CardContent sx={{ height: '100%', textAlign: 'center' }}>
                        <Typography sx={{ fontFamily: "Coolvetica", fontSize: { xs: '24px', sm: '28px', md: '28px', lg: '28px', xl: '28px' } }} variant="h6">
                            {entry.title}
                        </Typography>
                        <Typography variant="body2" sx={{ fontFamily: "Coolvetica", fontSize: { xs: '12px', sm: '18px', md: '18px', lg: '18px', xl: '18px' } }}>
                            {entry.description}
                        </Typography>
                        <Box sx={{ paddingTop: "5px" }}>
                            {entry.techStack.map((tech) => (
                                <Chip size="medium" sx={{ fontFamily: "Coolvetica", marginTop: '5px', marginRight: '5px' }} label={tech} />
                            ))}
                        </Box>
                    </CardContent>
                </Card>
            </CardActionArea>
        </Grid>
    )
}

export default PortfolioEntry;